/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_Aria_LabelInputs */

const en_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caption style`)
};

const fr_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style de sous-titre`)
};

const de_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriftenstil`)
};

const it_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile didascalia`)
};

const ru_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль подписи`)
};

const es_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de subtítulo`)
};

const zh_cn2_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题样式`)
};

const ja_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションスタイル`)
};

const hi_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन शैली`)
};

const pt_pt2_input_caption_style_aria_label = /** @type {(inputs: Input_Caption_Style_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo da legenda`)
};

/**
* | output |
* | --- |
* | "Caption style" |
*
* @param {Input_Caption_Style_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_aria_label = /** @type {((inputs?: Input_Caption_Style_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_caption_style_aria_label(inputs)
	if (locale === "de") return de_input_caption_style_aria_label(inputs)
	if (locale === "it") return it_input_caption_style_aria_label(inputs)
	if (locale === "ru") return ru_input_caption_style_aria_label(inputs)
	if (locale === "es") return es_input_caption_style_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_input_caption_style_aria_label(inputs)
	if (locale === "ja") return ja_input_caption_style_aria_label(inputs)
	if (locale === "hi") return hi_input_caption_style_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_input_caption_style_aria_label(inputs)
	return en_input_caption_style_aria_label(inputs)
});